import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { IClientsTreeNode } from './Administration/context/shared';
import { NodeTypes } from './variables';
import { centerClient } from '../shared/clients';
import type { SoapUser } from '../shared/generated';
import { toast } from 'react-toastify';
import generateApiKey from 'generate-api-key';
import ClientsTree from './Administration/ClientsTreeNew';

interface AddApiUserDialogProps {
    open: boolean;
    onClose: () => void;
    onUserAdded: () => void;
}

const AddApiUserDialog: React.FC<AddApiUserDialogProps> = ({ open, onClose, onUserAdded }) => {
    const [selectedAccount, setSelectedAccount] = useState<IClientsTreeNode | null>(null);
    const handleSelect = (node: IClientsTreeNode) => {
        if (node.type === NodeTypes.account) {
            setSelectedAccount(node);
        } else {
            setSelectedAccount(null);
        }
    };

    const handleAddUser = async () => {
        if (!selectedAccount) {
            toast.error('Выберите учетную запись для добавления.');
            return;
        }
        const apiKey = generateApiKey({ length: 16 });
        console.log(apiKey);
        const newUser: SoapUser = { Login: selectedAccount.name, ApiKey: apiKey as string };
        centerClient.addSoapUser(newUser)
            .then(() => {
                toast.success('Пользователь успешно добавлен!');
                onUserAdded();
                onClose();
            })
            .catch(() => void 0);
    };
    useEffect(() => {
        setSelectedAccount(null);
    },[open])
    return (
        <Modal id="addDeviceContainer" show={open} onHide={onClose} >
            <Modal.Header closeButton>
                <Modal.Title>Добавить пользователя API</Modal.Title>
            </Modal.Header>
            <Modal.Body>               
                <p>Выберите учетную запись из дерева:</p>
                <div style={{ height: 400}}>
                    <ClientsTree showTopButtons={false} selectFunc={handleSelect} selectedKey={selectedAccount?.key} treeKey={"center-openedTreeNodes-addApiUser"} />
                </div> 
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="custom"
                    onClick={handleAddUser}
                    disabled={!selectedAccount}
                >
                    Добавить
                </Button>
                <Button
                    variant="secondary"
                    onClick={onClose}
                    style={{ marginLeft: '1rem' }}
                >
                    Отмена
                </Button>
            </Modal.Footer>
        </Modal> 
    );
};

export default AddApiUserDialog;